export default {
  auth: {
    accessTokenKey: 'AUTH-LOCAL',
    externalProviderKey: 'AUTH-EXTERNAL'
  },
  uopt: 'UOPT',
  xsrf: {
    cookieName: 'XSRF-TOKEN',
    headerName: 'X-XSRF-TOKEN'
  }
};



// WEBPACK FOOTER //
// ./src/common/config.js